import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { SystemStatus } from "../../../system/systemEdit/SystemEdit.types.ts";
import { getEnumValues } from "@common/enumOperations.ts";
import { setFirstLetterToLowerCase } from "@common/stringOperations.ts";
import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";

export interface SystemStatusFieldProps {
    status?: SystemStatus;
    onChange: (status: SystemStatus) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
    isLoading: boolean;
}

function SystemStatusField(props: SystemStatusFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getSystemStatusOptions(translateString)}
            selectedItem={props.status?.toString()}
            onChange={
                props.readOnly
                    ? () => {}
                    : (type) => {
                          props.onChange(Number(type) as SystemStatus);
                      }
            }
            placeholder={translateString("status")}
            label={translateString("status")}
            noOptionsLabel={translateString("noOptions")}
            toolTipText={translateString("systemStatusTooltip")}
            disabled={props.disabled}
            errorText={props.errorText}
            disableClearable
            isLoading={props.isLoading}
        />
    );
}

export function getSystemStatusOptions(translateString: (key: string) => string): Array<DotLegalSelectOption> {
    return getEnumValues(SystemStatus).map((x) => {
        return { id: x.toString(), name: translateString(setFirstLetterToLowerCase(SystemStatus[x].toString())) };
    });
}

export default SystemStatusField;
